export { default } from "./DoctorSetup.gql";
